'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScreenReaderMessage = function (_BcReactComponent) {
  _inherits(ScreenReaderMessage, _BcReactComponent);

  function ScreenReaderMessage() {
    _classCallCheck(this, ScreenReaderMessage);

    return _possibleConstructorReturn(this, (ScreenReaderMessage.__proto__ || Object.getPrototypeOf(ScreenReaderMessage)).apply(this, arguments));
  }

  _createClass(ScreenReaderMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          props = _objectWithoutProperties(_props, ['id', 'className']);

      return _react2.default.createElement(
        'span',
        _extends({ className: 'sr-only ' + className, id: id }, props),
        this.props.children
      );
    }
  }]);

  return ScreenReaderMessage;
}(_baseBcReactComponent2.default);

ScreenReaderMessage.propTypes = {
  id: _react.PropTypes.string,
  localeKey: _react.PropTypes.string,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
};

exports.default = ScreenReaderMessage;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-screen-reader-message/lib/components/ScreenReaderMessage.component.js
// module id = 445
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11